/*
 * @Author: Xu Chen
 * @Date: 2019-05-07 16:59:02
 * @Last Modified by: gujt
 * @Last Modified time: 2022-02-21 11:25:00
 * @description: 作息策略
 */

import api from '@/api/strategy';
import util from '@/libs/util.js';
import { Message } from 'element-ui';

const strategy = {
  namespaced: true,
  state: {
    /* 作息策略列表 */
    strategyList: [],
    /* 作息策略是否应用于所有管理班级 1-是 0-否 */
    applyClass: '0'
  },

  mutations: {
    SET_STRATEGY_LIST: (state, strategyList) => {
      state.strategyList = strategyList;
    },

    SET_APPLY_CLASS: (state, applyClass) => {
      state.applyClass = applyClass;
    }
  },

  actions: {
    async setApplyClass({ commit }, applyClass) {
      commit('SET_APPLY_CLASS', applyClass);
    },

    async setStrategyList({ commit }, strategyList) {
      commit('SET_STRATEGY_LIST', strategyList);
    },

    /* 根据班级获取作息策略 */
    getStrategy({ commit }, payload) {
      return new Promise((resolve, reject) => {
        api
          .getStrategy(payload)
          .then(async response => {
            if (response.scheduleList) {
              let strategyList = [];
              for (let i = 0; i < response.scheduleList.length; i += 1) {
                let strategyItem = {
                  name: '',
                  startTime: '',
                  endTime: ''
                };
                strategyItem.name = response.scheduleList[i].name;
                const start =
                  response.scheduleList[i].effectiveDate +
                  ' ' +
                  response.scheduleList[i].startTime +
                  ':00';
                const end =
                  response.scheduleList[i].effectiveDate +
                  ' ' +
                  response.scheduleList[i].endTime +
                  ':00';
                strategyItem.startTime = new Date(start.replace(new RegExp(/-/gm), '/'));
                strategyItem.endTime = new Date(end.replace(new RegExp(/-/gm), '/'));
                strategyList.push(strategyItem);
              }
              commit('SET_STRATEGY_LIST', strategyList);
            }
            // 结束
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    /* 对班级设置作息策略 */
    async setStrategy({ state }, payload) {
      return new Promise((resolve, reject) => {
        const params = {
          userId: util.cookies.get('uuid'),
          applyClass: state.applyClass,
          schedule: state.strategyList,
          ...payload
        };
        api
          .setStrategy(params)
          .then(async response => {
            Message.success('作息时间设置成功');
            window.location.reload();
            // 结束
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  }
};

export default strategy;
